import { getLoanLiquidation } from '@/services/loans.service';
import { redirectNotFound } from '@/utils/errorRedirect';

const Model = {
  namespace: 'loanLiquidationDetails',
  state: {
    liquidation: null,
  },

  effects: {
    *fetchLiquidation({ payload }, { call, put }) {
      try {
        const response = yield call(getLoanLiquidation, payload.id);
        yield put({
          type: 'show',
          payload: { liquidation: response.data },
        });
      } catch (error) {
        redirectNotFound(error);
      }
    },
  },

  reducers: {
    show(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
export default Model;
